import { Market, isUsMarket } from "utils/market";

export type AppMode = Market | "content";

export const isContentOnly = process.env.REACT_APP_CONTENT_ONLY === "true";

export const currentMode: AppMode = isContentOnly ? "content" : isUsMarket ? Market.US : Market.EU;
